// Global
import fastclick from 'fastclick';

// Vendors
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'sharer.js';
import 'formdata-polyfill';
import './modules/remodal';
import './modules/lightbox';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Components
import cookieBanner from '../../templates/components/cookie-banner';
import headerToggle from '../../templates/components/header/header-toggle';
import headerSearch from '../../templates/components/header/search';
import enquiryForm from '../../templates/components/enquiry-form';
import enquiryTracking from '../../templates/components/enquiry-form/tracking';
import headerClose from '../../templates/components/header/close';
import menuOpener from '../../templates/components/header/menu-opener';
import menu from '../../templates/components/menu';
import pageOverlay from '../../templates/components/page-overlay';
import heroCarousel from '../../templates/components/hero-carousel';
import storageCounter from '../../templates/components/hero-carousel/StorageCounter'
import secondaryBody from '../../templates/components/text-block/secondary-body';
import cardCarousel from '../../templates/components/card-carousel';
import accordion from '../../templates/components/accordion';
import videoBlock from '../../templates/components/video-block';
import singleMap from '../../templates/components/single-map';
import gallerySlider from '../../templates/components/gallery-slider';
import sfPriceCalculator from '../../templates/components/price-calculator/store-first';
import bfPriceCalculator from '../../templates/components/price-calculator/business-first';
import textField from '../../templates/components/text-field';
import textarea from '../../templates/components/textarea';
import locationList from '../../templates/components/location-list';
import locationFooter from '../../templates/components/location-footer';
import locationFooterNavOpener from '../../templates/components/location-footer/nav-opener';
import locationCard from '../../templates/components/location-card';
import toggleMap from '../../templates/components/location-list/toggle-map';
import mobileMapOpener from '../../templates/components/location-list/mobile-map-opener';
import articlesList from '../../templates/components/articles-list';
import filterOpener from '../../templates/components/articles-list/filter-opener';
import tabs from '../../templates/components/tabs';
import social from '../../templates/components/social';
import reviewCards from '../../templates/components/review-cards';
import handleBrochureDownload from '../../templates/components/hero/brochure'
import handleBookViewing from '../../templates/components/bookviewing-form/bookviewing'
import newsletterSignupForm from '../../templates/components/footer/components/newsletter-form';
import timeline from '../../templates/components/timeline/timeline';
import propertiesList from '../../templates/components/properties-list';
import iframeSlider from '../../templates/components/iframe-slider';
import comparisonPriceTable from '../../templates/components/comparison-price-table';

// Global
fastclick.attach(document.body);

// Components
cookieBanner();
headerToggle();
headerSearch();
headerClose();
menuOpener();
menu();
pageOverlay();
heroCarousel();
storageCounter();
secondaryBody();
cardCarousel();
accordion();
videoBlock();
singleMap();
gallerySlider();
sfPriceCalculator();
bfPriceCalculator();
locationList();
locationFooter();
locationFooterNavOpener();
locationCard();
toggleMap();
mobileMapOpener();
articlesList();
filterOpener();
tabs();
// social();
reviewCards();
enquiryForm();
enquiryTracking();
newsletterSignupForm();
timeline();
handleBrochureDownload();
handleBookViewing();
propertiesList();
iframeSlider();
comparisonPriceTable();

document.addEventListener('DOMContentLoaded', async () => {
    textField();
    textarea();
});
